"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const dayoff_types_1 = require("./dayoff.types");
const initialState = {
    dataGrid: [],
    errorCode: 0,
    dataCalendar: [],
    isError: false,
    isLoading: true,
    errorMessage: '',
    isSuccess: false,
    isSyncDayOff: false,
    mutationMode: false,
    lastUpdated: new Date(),
    dataItem: {
        id: '',
        event_day: '',
        created_by: '',
        modified_by: '',
        is_deleted: false,
        date_off: new Date(),
        created_date: new Date(),
        modified_date: new Date(),
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'date_off', dir: 'asc' }]
    }
};
const adjustmentDayoffReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [dayoff_types_1.adjustmentDayOffTypes.SET_DATA_GRID]: (state, action) => {
        const { count, dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [dayoff_types_1.adjustmentDayOffTypes.SET_DATA_CALENDAR]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataCalendar: action.payload.dataCalendar });
    },
    [dayoff_types_1.adjustmentDayOffTypes.SYNC_DATA_CALENDAR]: (state, action) => {
        console.log(action.payload.message);
        return Object.assign(Object.assign({}, state), { isLoading: true, isSyncDayOff: false });
    },
    [dayoff_types_1.adjustmentDayOffTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [dayoff_types_1.adjustmentDayOffTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [dayoff_types_1.adjustmentDayOffTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [dayoff_types_1.adjustmentDayOffTypes.ON_DELETE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, isLoading: true, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter(item => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [dayoff_types_1.adjustmentDayOffTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false, isSyncDayOff: false });
    },
    [dayoff_types_1.adjustmentDayOffTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [dayoff_types_1.adjustmentDayOffTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [dayoff_types_1.adjustmentDayOffTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    },
    [dayoff_types_1.adjustmentDayOffTypes.ON_SYNC_DATA]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isSyncDayOff: action.payload });
    },
});
exports.default = adjustmentDayoffReducer;
